import * as Wysimark from '@wysimark/react'
export * from '@wysimark/react'
export default Wysimark
export { Wysimark }